import dash_api from '../support/dash_api';
import { generateConstants } from '../support/utils';
import AppsActions from '../actions/AppsActions_LEGACY';
import { updateApp } from '../../common/actions/AppActions';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';

const errorProvider = new ErrorProvider();
export const SUBDOMAIN_AVAILABILITY = generateConstants('SUBDOMAIN_AVAILABILITY');
export const SUBDOMAIN_GET = generateConstants('SUBDOMAIN_GET');
export const UPDATE_CUSTOM_DOMAIN = generateConstants('UPDATE_CUSTOM_DOMAIN');

export function linkSettingsLoad() {
  return function (dispatch) {
    return dispatch({
      type: 'LINKSETTINGS_LOAD',
    });
  };
}

export function changeInEnv() {
  return function (dispatch) {
    return dispatch({
      type: 'CHANGE_IN_ENV',
    });
  };
}

export function subdomainOpen() {
  return function (dispatch) {
    return dispatch({
      type: 'SUBDOMAIN_OPEN',
    });
  };
}

export function subdomainCancel() {
  return function (dispatch) {
    return dispatch({
      type: 'SUBDOMAIN_CANCEL',
    });
  };
}

export function subdomainChange(subdomain) {
  return function (dispatch) {
    return dispatch({
      type: 'SUBDOMAIN_ONCHANGE',
      data: subdomain,
    });
  };
}

export function subdomainInvalid(message) {
  return function (dispatch) {
    return dispatch({
      type: 'SUBDOMAIN_INVALID',
      data: message,
    });
  };
}

export function domainOpen() {
  return function (dispatch) {
    return dispatch({
      type: 'DOMAIN_OPEN',
    });
  };
}

export function domainCancel() {
  return function (dispatch) {
    return dispatch({
      type: 'DOMAIN_CANCEL',
    });
  };
}

export function domainInvalid(message) {
  return function (dispatch) {
    return dispatch({
      type: 'DOMAIN_INVALID',
      data: message,
    });
  };
}

export function checkSubDomainAvailability(subdomain) {
  return function (dispatch) {
    return dash_api
      .get(`/v1/subdomain/available/${subdomain}`)
      .then(({ data }) =>
        dispatch({
          type: SUBDOMAIN_AVAILABILITY.response,
          subdomain,
          data,
        })
      )
      .catch((error) =>
        dispatch({
          type: SUBDOMAIN_AVAILABILITY.error,
          subdomain,
          error: errorProvider.parse(error).getResponse(),
        })
      );
  };
}

export function changeSubdomain(subdomain, appId, disableFluxAction) {
  return function (dispatch) {
    dispatch({
      type: SUBDOMAIN_GET.request,
    });

    return dash_api
      .post(`/v1/subdomain/change-to/${subdomain}`)
      .then(({ data }) => {
        // this hack hurts but will remove once we refactor link settings to use redux
        if (disableFluxAction) {
          dispatch(updateApp(data, true));
        } else {
          AppsActions.setCustomSubDomainLocally(data);
        }

        return dispatch({
          type: SUBDOMAIN_GET.response,
          data,
        });
      })
      .catch((error) =>
        dispatch({
          type: SUBDOMAIN_GET.error,
          error: errorProvider.parse(error).getResponse(),
        })
      );
  };
}

export function setCustomDomain(domain) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_CUSTOM_DOMAIN.request,
    });
    return dash_api
      .put('/v1/subdomain/custom-domain', {
        customDomain: domain,
      })
      .then(({ data }) => {
        dispatch({
          type: UPDATE_CUSTOM_DOMAIN.response,
          domain: domain,
          data,
        });
        AppsActions.setLocally({ short_url_domain: domain });
      })
      .catch((error) =>
        dispatch({
          type: UPDATE_CUSTOM_DOMAIN.error,
          domain: domain,
          error: errorProvider.parse(error).getResponse(),
        })
      );
  };
}
